

export interface TargetGroupItem {
  title: string;
  icon: string;
  content: Array<{ title: string; percentage: number }>;
}

export function buildTargetGroupsItems(raw: unknown): TargetGroupItem[] {
  const rows = Array.isArray(raw) ? raw : [];

  const sorted = rows
    .filter(Boolean)
    .sort((a: any, b: any) => Number(a?.order ?? 0) - Number(b?.order ?? 0));

  const groups: TargetGroupItem[] = [];
  let current: TargetGroupItem | null = null;

  for (const it of sorted) {
    const level = Number(it?.level ?? 0);
    const label = String(it?.label ?? '').trim();
    const icon = String(it?.icon ?? '').replace(/-/g, '_');

    if (level === 0) {
      current = { title: label, icon, content: [] };
      groups.push(current);
    } else if (level === 1 && current) {
      const rawVal = String(it?.value ?? '0');

      const valueNum = Number(rawVal.replace(/[^\d.]/g, '')) || 0;
      current.content.push({ title: label, percentage: valueNum });
    }
  }

  return groups.map(g => {
    const vals = g.content.map(c => Number(c.percentage || 0));
    const sum = vals.reduce((a, b) => a + b, 0);
    const looksLikeCounts = vals.some(v => v > 100) || sum > 100;

    const content = g.content.map((c, i) => {
      const val = looksLikeCounts ? (sum ? (vals[i] / sum) * 100 : 0) : vals[i];
      const p = Math.max(0, Math.min(100, Math.round(val)));
      return { ...c, percentage: p };
    });

    return { ...g, content };
  });
}
